import React, { useState, useEffect, memo } from 'react'
import dayjs from 'dayjs'
import { ReactComponent as LittleArrowBottomArrowIcon } from '../../assets/icons/app/bottom.icon.svg'
import { PeriodTypeEnum } from '../../core/enums/period-type.enum'
import DynamicsResultsPeriodDateType from '../dynamics-results/filters/request-filters/period/DynamicsResultsPeriodDateType'
import {
  PeriodsFiltersContainerStyle,
  PeriodsFiltersLabelStyle,
  PeriodsFiltersMenuStyle,
} from './PeriodsFiltersStyles'

const AnalyticDateMonthFilters = ({
  handleChangeQuery,
  startDateSelected,
  endDateSelected,
  menuKey,
  disabled = false,
}: {
  handleChangeQuery: (key: any, value: any) => void
  startDateSelected: string
  endDateSelected: string
  menuKey: string
  disabled?: boolean
}) => {
  let timer: NodeJS.Timeout | null = null
  const [needClose, setNeedClose] = useState<boolean>(false)
  const [hasHover, setHasHover] = useState<boolean>(false)

  const [menuOpen, setMenuOpen] = useState<string | null>(null)

  const handleTimeOut = () => {
    timer = setTimeout(() => {
      if (menuOpen === menuKey) {
        setMenuOpen(null)
      }
      setNeedClose(false)
    }, 300)
  }

  useEffect(() => {
    if (needClose && !hasHover) {
      handleTimeOut()
    }

    return () => {
      if (timer) {
        clearTimeout(timer)
      }
    }
  }, [needClose, hasHover, timer, menuOpen])

  const handleMouseEnter = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => {
    if (disabled) return
    event.preventDefault()
    setMenuOpen(menuKey)
    setHasHover(true)
  }

  const handleMouseLeave = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => {
    if (disabled) return
    event.preventDefault()
    setHasHover(false)
    setNeedClose(true)
  }

  return (
    <PeriodsFiltersContainerStyle
      className="flex flex-col relative bg-white catalog-filter"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      disabled={disabled}
    >
      <PeriodsFiltersLabelStyle
        className="w-full h-full flex flex-row justify-between items-center catalog-filter"
        disabled={disabled}
      >
        <span>{dayjs(startDateSelected).format('MMMM YYYY')}</span>
        <LittleArrowBottomArrowIcon
          className={disabled ? 'text-[#929292]' : 'text-[#b2b2b2]'}
        />
      </PeriodsFiltersLabelStyle>
      <PeriodsFiltersMenuStyle
        open={!disabled && menuOpen === menuKey}
        className="shadow-2xl z-45 catalog-filter"
      >
        <div className="catalog-filter">
          <DynamicsResultsPeriodDateType
            menuIsOpen={!disabled && menuOpen === menuKey}
            periodTypeSelected={PeriodTypeEnum.MONTH}
            startDateSelected={startDateSelected}
            endDateSelected={endDateSelected}
            handleChangeQuery={handleChangeQuery}
          />
        </div>
      </PeriodsFiltersMenuStyle>
    </PeriodsFiltersContainerStyle>
  )
}

export default memo(AnalyticDateMonthFilters)
